import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as React from "react";
import * as styles from "./about-hero.css.ts";
import { Container, Section, SuperHeading, Text } from "./ui";

export default function AboutHero(props) {
  return (
    <Section>
      <Container >
       
          <SuperHeading className={styles.aboutHeroHeader}>{props.heading}</SuperHeading>
          {props.text && <Text className={styles.aboutHeroText}>{props.text}</Text>}
       
      </Container>
      <Container width="narrow">
        {props.image && (
          <GatsbyImage alt={props.image.alt} image={getImage(props.image)} className={styles.aboutHeroImage} />
        )}
      </Container>
    </Section>
  );
}

export const query = graphql`
  fragment AboutHeroContent on AboutHero {
    id
    heading
    text
    image {
      id
      gatsbyImageData
      alt
    }
  }
`;
